module.exports = __webpack_public_path__ + "img/insta.b2b01d0d.svg";